const PolicyContent = ({ templateData }) => {
  return templateData.map((template, i) => {
    const items = []
    if (template.type === 'copy' || template.type === 'policytable') {
      items.push(
        <div
          key={`policy-item-${i}`}
          className="privacy-policy__row"
          dangerouslySetInnerHTML={{ __html: template.value }}
        />
      )
    }
    return items
  })
}

export default PolicyContent
